<div class="contest-card__wrapper">
  <div class="contest-card__content">
    <div class="contest-card__primary-content">
      @if (contest.name) {
        <h2
        class="contest-card__title">{{ contest.name }}</h2>
      }
      @if (contest.description) {
        <p
        class="contest-card__subtitle" [innerHTML]="contest.description"></p>
      }
      <div class="contest-card__informations">
        @if (contest.goals) {
          <div
            class="contest-card__goals">
            <h3>{{ "contest.goals_title" | translate }}</h3>
            <p [innerHTML]="contest.goals"></p>
          </div>
        }
        @if (contest.rulesAlias) {
          <div class="contest-card__rules">
            <a [routerLink]="['/page', contest.rulesAlias]">{{ "contest.see_rules" | translate }}</a>
          </div>
        }
      </div>
    </div>
    <div class="contest-card__secondary-content">
      <app-contest-timer [targetDate]="contest.startDate"></app-contest-timer>
      <div class="contest-card__rewards" [innerHTML]="contest.prizes"></div>
    </div>
  </div>
  <div class="contest-card__footer">
    @if (contest.startDate && contest.endDate) {
      <div
        class="contest-card__dates">
        <div class="contest-card__start-date">
          <mat-icon svgIcon="event-upcoming"></mat-icon>
          <div>{{ "contest.from" | translate }} {{ contest.startDate | date: 'longDate' }}</div>
        </div>
        <div class="contest-card__end-date">
          <mat-icon svgIcon="event-available"></mat-icon>
          <div>{{ "contest.to" | translate }} {{ contest.endDate | date: 'longDate' }}</div>
        </div>
      </div>
    }
    <div class="contest-card__inscription">
      @if (!isRegistered) {
        @if (canRegister && userHasRoleForContest()) {
          <button
            (click)="registerToContest()"
            [disabled]="isRegistering"
            >
            <div>{{ "contest.register_self" | translate }}</div>
            @if (!isRegistering) {
              <mat-icon svgIcon="register"></mat-icon>
            } @else {
              <mat-spinner diameter="24"></mat-spinner>
            }
          </button>
        }
      } @else {
        @if (canShareCode) {
          <div class="contest-card__shareable-code"
            (click)="copyShareableCode()"
            (mouseenter)="onEnterShareableCode()"
            (mouseleave)="onLeaveShareableCode()"
            >
            {{ 'contest.my_sponsor_code' | translate }}
            <span>{{ shareableCode }}</span>
            <div class="contest-card__shareable-code-tooltip"
              matTooltip="{{ shareableCodeTooltip | translate}}"
            #shareableCodeBlock="matTooltip"></div>
          </div>
        }
        @if (!isOpen) {
          <div class="contest-card__shareable-code">
            {{ 'contest.registered' | translate }}
          </div>
          @if (canRegisterGroups) {
            <button
              (click)="editRegistration()"
              [disabled]="isRegistering"
              >
              <div>{{ "contest.edit_register_self" | translate }}</div>
              @if (!isRegistering) {
                <mat-icon svgIcon="register"></mat-icon>
              } @else {
                <mat-spinner diameter="24"></mat-spinner>
              }
            </button>
          }
        }
        @if (isOpen) {
          <a
            [routerLink]="['/contests', contest.id, 'home']">
            <div>{{ "contest.open" | translate }}</div>
            <mat-icon svgIcon="register"></mat-icon>
          </a>
        }
      }
    </div>
  </div>
</div>

